import React, {useEffect, useRef, useState} from 'react'
import {Lang} from 'yougile-lang'
import {Icon} from '@components/common/base/icon'
import {
  keyboardHandler,
  textCursorSelectAll,
  useClickAway
} from '@containers/hooks'
import {TwLabelContainer, TwLabelInput} from './containers'

interface Props {
  label?: string
  onSubmit: (label?: string) => void
}

export const PinnedLabelEditing = ({label = '', onSubmit}: Props) => {
  const labelInputRef = useRef<HTMLInputElement>(null)
  const [localLabel, setLocalLabel] = useState(label)
  useEffect(() => {
    setLocalLabel(label)
  }, [label])
  const onLabelCancel = () => {
    onSubmit()
    return true
  }
  const onLabelSubmit = () => onSubmit(localLabel)
  useClickAway(labelInputRef, onLabelSubmit, ['mousedown', 'click'], true)

  return (
    <TwLabelContainer content="">
      <Icon icon="IconPinned" size={16} color="secondary" />
      <TwLabelInput
        autoFocus
        ref={labelInputRef}
        value={localLabel}
        onFocus={textCursorSelectAll}
        onKeyDown={keyboardHandler({
          enter: onLabelSubmit,
          escape: onLabelCancel
        })}
        placeholder={Lang.msg.labelPlaceholder}
        onChange={e => setLocalLabel(e.target.value)}
      />
    </TwLabelContainer>
  )
}
